var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickyNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12164288,3.8340864 L5.7511296,3.8340864 L5.7511296,0.67096512 C5.7511296,0.511610904 5.62292734,0.38340864 5.46357312,0.38340864 L0.67096512,0.38340864 C0.511610904,0.38340864 0.38340864,0.511610904 0.38340864,0.67096512 L0.38340864,5.46357312 C0.38340864,5.62292734 0.511610904,5.7511296 0.67096512,5.7511296 L3.8340864,5.7511296 L3.8340864,4.12164288 C3.8340864,3.96348682 3.96348682,3.8340864 4.12164288,3.8340864 Z M5.66725896,4.49307 L4.49307,5.66725896 C4.43915316,5.7211758 4.36606589,5.7511296 4.28938416,5.7511296 L4.21749504,5.7511296 L4.21749504,4.21749504 L5.7511296,4.21749504 L5.7511296,4.29058231 C5.7511296,4.36606589 5.7211758,4.43915316 5.66725896,4.49307 Z",
    id: "path-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyNote);
export default __webpack_public_path__ + "static/media/sticky-note.cc667833f7247094a9ef7ba441a50a3f.svg";
export { ForwardRef as ReactComponent };